import { useTranslations } from '@vocab/react';
import {
  Box,
  Heading,
  ButtonLink,
  Text,
  Hidden,
  Inline,
  IconPlatformApple,
  IconPlatformAndroid,
} from 'braid-design-system';

import { APP_PLATFORMS } from 'src/core/domain/constants';
import { convertSvgToBase64 } from 'src/core/utils/fileUtil';
import appBannerImage from 'src/images/app-banner.svg';
import { useAnalytics } from 'src/provider/analytics';
import { usePage } from 'src/provider/page';

import translations from './.vocab';

export const AppBanner = () => {
  const { t } = useTranslations(translations);
  const { trackAnalyticsInteraction } = useAnalytics();
  const {
    pageState: { pageName, threadId },
  } = usePage();
  if (pageName !== 'CommunityThreadDetails') return null;

  return (
    <Hidden below="tablet">
      <Box
        background="neutralLight"
        borderRadius="standard"
        paddingTop="large"
        paddingBottom="xlarge"
        paddingX={{
          desktop: 'xlarge',
          tablet: 'large',
        }}
        style={{
          borderRadius: '20px',
          maxWidth: '1140px',
        }}
        display="flex"
      >
        <Box>
          <Heading
            align={{
              tablet: 'left',
            }}
            level="2"
          >
            {t('communityExperience')}
          </Heading>
          <Box paddingTop="small">
            <Inline space="gutter">
              <Text
                align={{
                  tablet: 'left',
                }}
                tone="secondary"
              >
                {t('features')}
              </Text>
              {APP_PLATFORMS.map(({ link, platform }) => (
                <Box key={platform} style={{ width: '233px', height: '48px' }}>
                  <ButtonLink
                    variant="solid"
                    size="standard"
                    href={link}
                    target="_blank"
                    icon={
                      platform === 'apple' ? (
                        <IconPlatformApple />
                      ) : (
                        <IconPlatformAndroid />
                      )
                    }
                    onClick={() =>
                      trackAnalyticsInteraction('AppBannerClick', {
                        threadId,
                        nudgeType: t('nudgeType'),
                        message: t('nudgeMessage'),
                        linkText: t('linkText'),
                      })
                    }
                  >
                    {platform === 'apple' ? t('appStore') : t('googlePlay')}
                  </ButtonLink>
                </Box>
              ))}
            </Inline>
          </Box>
        </Box>
        <Box style={{ maxWidth: 176 }} paddingLeft="xlarge">
          <img src={convertSvgToBase64(appBannerImage)} />
        </Box>
      </Box>
    </Hidden>
  );
};

export default AppBanner;
